<template>
  <CHeader fixed with-subheader light>
    <CHeaderNavLink to="/" class="d-flex align-items-center">
      <img
        src="/img/EIBlogo2.png"
        alt=""
        style="max-height: 50px; width: 175px; object-fit: contain"
      />
    </CHeaderNavLink>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderNav class="ml-auto">
      <CSelect
        class="mr-3 mb-1"
        :value.sync="$i18n.locale"
        :options="languages"
        @update:value="setLanguage"
      />
      <div class="mr-3">
        {{ login }}
      </div>
      <div class="logout" @click="logout" data-cy="logout">
        <i class="fa fa-lock"/>
        <span>
          {{ $t('Logout') }}
        </span>
      </div>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import { freeSet } from '@coreui/icons';
import { ActiveUser } from '@/services/user';
import { LanguageMixin } from '@/mixins/language';

export default {
  name: 'TheHeader',
  mixins: [LanguageMixin],
  freeSet,
  data() {
    return {
      login: ActiveUser.get()?.email,
    };
  },
  methods: {
    logout() {
      ActiveUser.clear();
      this.$router.replace({ name: 'Login' });
    },
  },
};
</script>

<style scoped lang="scss">
.logout {
  cursor: pointer;
  border-bottom: 1px solid transparent;

  &:hover {
    border-color: $gray-base;
  }
}
</style>
